// extracted by mini-css-extract-plugin
export default {"settings":"pane_settings__pMrAs","multiline":"pane_multiline__9rmlR"};